'use client';

import tinycolor from "../../../external/tinycolor2/esm/tinycolor.js";
import { getOnActionColor } from "./getOnActionColor.js";
import { getBorderActionFallback } from "./getBorderActionFallback.js";
import { getPrimaryPalette } from "./getPrimaryPalette.js";
import { getPrimarySafePalette } from "./getPrimarySafePalette.js";
const getThemedPalette = (primaryColor) => {
  if (tinycolor(primaryColor).isValid()) {
    const primaryPalette = getPrimaryPalette(primaryColor);
    const primarySafePalette = getPrimarySafePalette(
      primaryColor,
      primaryPalette
    );
    return {
      action: {
        primary: primaryPalette,
        primarySafe: primarySafePalette
      },
      onAction: {
        primary: {
          lightest: getOnActionColor(primaryPalette.lightest),
          light: getOnActionColor(primaryPalette.light),
          base: getOnActionColor(primaryPalette.base),
          dark: getOnActionColor(primaryPalette.dark),
          darkest: getOnActionColor(primaryPalette.darkest)
        },
        primarySafe: {
          lightest: getOnActionColor(primarySafePalette.lightest),
          light: getOnActionColor(primarySafePalette.light),
          base: getOnActionColor(primarySafePalette.base),
          dark: getOnActionColor(primarySafePalette.dark),
          darkest: getOnActionColor(primarySafePalette.darkest)
        }
      },
      onLight: {
        border: {
          actionPrimaryFallback: getBorderActionFallback(
            primaryPalette.dark,
            "onLight",
            primaryPalette
          ),
          actionPrimarySafeFallback: getBorderActionFallback(
            primarySafePalette.dark,
            "onLight",
            primarySafePalette
          )
        }
      },
      onDark: {
        border: {
          actionPrimaryFallback: getBorderActionFallback(
            primaryPalette.base,
            "onDark",
            primaryPalette
          ),
          actionPrimarySafeFallback: getBorderActionFallback(
            primarySafePalette.base,
            "onDark",
            primarySafePalette
          )
        }
      }
    };
  }
  return void 0;
};
export {
  getThemedPalette
};
